// extracted by mini-css-extract-plugin
module.exports = {"beta":"beta-1YXxn","loading":"loading-1UemB"};